import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MbConstants } from '../../../../shared/mb-constants'
import { MbCheckoutRegions, MbPaymentMode, MbPaymentModeSelection } from '../../../../models'
import { BaseSiteService } from '@spartacus/core'
import { MbPaymentMethodsComponent } from 'src/app/mb/cart/components/mb-payment-methods/mb-payment-methods.component'

@Component({
  selector: 'mb-checkout-billing-common-payment-tile',
  templateUrl: './mb-checkout-billing-common-payment-tile.component.html',
  styleUrls: ['./mb-checkout-billing-common-payment-tile.component.scss']
})
export class MbCheckoutBillingCommonPaymentTileComponent extends MbPaymentMethodsComponent {

  checkoutRegions = MbCheckoutRegions
  @Input() paymentMode: MbPaymentMode | undefined

  @Input() isSelectedPayment: boolean = false

  @Input() formRegion = this.checkoutRegions.EU

  @Output() paymentModeSelected = new EventEmitter<MbPaymentModeSelection>()

  constants = MbConstants

  constructor (protected baseSiteService: BaseSiteService) {
    super(baseSiteService)
   }

  onPaymentModeSelected (value?: MbPaymentMode) {
    this.paymentModeSelected.emit({ paymentMode: value, poNumber: undefined })
  }
}
